export const PROJECT_STATUS_LIST = ['archive', 'active', 'complete'];
export const TASK_STATUS_LIST = ['not started', 'in progress', 'completed', 'blocked'];
export const DEFAULT_PROJECT_STATUS = 'active';
export const PROJECT_EDITOR_ROLE = ['Project Manager', 'Project Owner', 'Team Leader'];
export const ROLE_LEVEL = {
  'Project Owner': 1,
  Stakeholder: 2,
  'Project Manager': 3,
  'Team Leader': 4,
};
export const ROLE_CAN_REMOVE_PROJECT = ['Project Owner'];
export const GUEST = 'Stakeholder';
export const TASK_TYPE_LIST = ['Task', 'Issue', 'CR'];
export const ROLE_CAN_UPDATE_TASK_CLASSIFICATION = ['Project Owner', 'Project Manager', 'Team Leader' , "QA"];
export const ROLE_CAN_EDIT_TASK_DETAILS_DATE = ROLE_CAN_UPDATE_TASK_CLASSIFICATION;